(function () {
  const reviewAppContainers = document.querySelectorAll(".review-extension-container");

  reviewAppContainers.forEach((container) => {
    const sectionId = container.dataset.sectionId;
    const productId = container.dataset.productId;
    const shopDomain = container.dataset.shopDomain;
    const starColorFilled = container.dataset.starFilledColor || "#FFD700";
    const starColorEmpty = container.dataset.starEmptyColor || "#CCCCCC";
    const loadMoreBtn = container.querySelector(`#load-more-btn-${sectionId}`);
    const loadMoreContainer = container.querySelector(`#load-more-container-${sectionId}`);
    const reviewListContainer = container.querySelector(`#reviews-list-${sectionId}`);
    const reviewsSpinner = container.querySelector(`#reviews-spinner-${sectionId}`);
    const reviewSummaryContainer = container.querySelector(`#review-summary-${sectionId}`);

    const API_BASE_URL = `/apps/${APP_SUB_PATH}/customer/product-review`;

    // Review detail modal
    const reviewDetailModal = document.getElementById(`review-detail-modal-${sectionId}`);
    const reviewDetailModalContent = document.getElementById(`review-detail-modal-content-${sectionId}`);
    const reviewDetailModalClose = document.getElementById(`review-detail-modal-close-${sectionId}`);
    const reviewDetailImage = document.getElementById(`review-detail-image-${sectionId}`);
    const reviewDetailStars = document.getElementById(`review-detail-stars-${sectionId}`);
    const reviewDetailText = document.getElementById(`review-detail-text-${sectionId}`);
    const reviewDetailDate = document.getElementById(`review-detail-date-${sectionId}`);
    const reviewDetailAuthor = document.getElementById(`review-detail-author-${sectionId}`);

    function openReviewDetailModal(review) {
      if (!reviewDetailModal) return;

      if (reviewDetailImage) {
        if (review.reviewImage) {
          reviewDetailImage.innerHTML = `<img src="${review.reviewImage}" alt="${escapeHTML(review.reviewText ? review.reviewText.substring(0, 20) : "")}" class="w-full rounded-8 max-h-350 object-cover" loading="lazy">`;
          reviewDetailImage.style.setProperty("display", "flex", "important");
        } else {
          reviewDetailImage.innerHTML = "";
          reviewDetailImage.style.setProperty("display", "none", "important");
        }
      }

      if (reviewDetailStars) {
        reviewDetailStars.innerHTML = createStarRating(review.rating);
      }

      if (reviewDetailText) {
        reviewDetailText.textContent = review.reviewText || "";
      }

      if (reviewDetailDate) {
        reviewDetailDate.textContent = review.reviewPlacedAt ? formatDate(review.reviewPlacedAt) : "N/A";
      }

      if (reviewDetailAuthor) {
        reviewDetailAuthor.textContent = `By ${review.customerName || "Anonymous"}`;
      }

      reviewDetailModal.classList.remove("hidden");
      document.body.style.overflow = "hidden";
    }

    function closeReviewDetailModal() {
      if (!reviewDetailModal) return;
      reviewDetailModal.classList.add("hidden");
      document.body.style.overflow = "";
    }

    if (reviewDetailModalClose) {
      reviewDetailModalClose.addEventListener("click", closeReviewDetailModal);
    }

    if (reviewDetailModal) {
      reviewDetailModal.addEventListener("click", function (e) {
        if (reviewDetailModalContent && !reviewDetailModalContent.contains(e.target)) {
          closeReviewDetailModal();
        }
      });
    }

    let allProductReviews = [];
    let currentPage = 1;
    let isLoadingMore = false;
    let hasMoreReviews = false;

    if (loadMoreBtn) {
      loadMoreBtn.addEventListener("click", async function () {
        if (!isLoadingMore && hasMoreReviews) {
          isLoadingMore = true;
          await fetchReviews(currentPage + 1, true);
          isLoadingMore = false;
        }
      });
    }

    function createStarRating(rating) {
      let starsHtml = "";
      for (let i = 1; i <= 5; i++) {
        starsHtml +=
          i <= rating
            ? `<span class="text-brand" style="font-size: 20px">★</span>`
            : `<span class="text-bg" style="font-size: 20px;">★</span>`;
      }
      return starsHtml;
    }

    function formatDate(dateString) {
      return new Date(dateString).toLocaleDateString("en-US", {
        year: "numeric",
        month: "short",
        day: "numeric",
      });
    }

    // New function to handle read more functionality
    function createReviewTextWithReadMore(reviewText, uniqueId) {
      if (!reviewText) return "";

      const maxLength = 150; // Characters to show before "Read More"

      if (reviewText.length <= maxLength) {
        return `<div class="ff-general-sans fs-14-lh-20-ls-0 fw-400 text-secondary">
          ${escapeHTML(reviewText)}
        </div>`;
      }

      const truncatedText = reviewText.substring(0, maxLength);
      const remainingText = reviewText.substring(maxLength);

      return `<div class="ff-general-sans fs-14-lh-20-ls-0 fw-400 text-secondary">
        <span class="review-text-short" id="short-${uniqueId}">
          ${escapeHTML(truncatedText)}...
          <button class="read-more-btn bg-transparent border-none text-brand no-underline cursor-pointer ff-general-sans fs-14-lh-20-ls-0 fw-500 pl-0" onclick="event.stopPropagation(); toggleReadMore('${uniqueId}')">
            Read More
          </button>
        </span>
        <span class="review-text-full hidden" id="full-${uniqueId}">
          ${escapeHTML(reviewText)}
          <button class="read-less-btn bg-transparent border-none text-brand no-underline cursor-pointer ff-general-sans fs-14-lh-20-ls-0 fw-500 pl-0" onclick="event.stopPropagation(); toggleReadMore('${uniqueId}')">
            Read Less
          </button>
        </span>
      </div>`;
    }

    // Add global function for toggling read more
    window.toggleReadMore = function (uniqueId) {
      const shortText = document.getElementById(`short-${uniqueId}`);
      const fullText = document.getElementById(`full-${uniqueId}`);

      if (shortText && fullText) {
        if (shortText.classList.contains("hidden")) {
          shortText.classList.remove("hidden");
          fullText.classList.add("hidden");
        } else {
          shortText.classList.add("hidden");
          fullText.classList.remove("hidden");
        }
      }
    };

    async function fetchReviews(page = 1, append = false) {
      if (!reviewListContainer || !productId) return;

      if (!append) {
        if (reviewsSpinner) reviewsSpinner.style.display = "flex";
        if (reviewListContainer) reviewListContainer.innerHTML = "";
        allProductReviews = [];
      } else if (loadMoreBtn) {
        loadMoreBtn.disabled = true;
        loadMoreBtn.textContent = "Loading...";
      }

      try {
        const response = await fetch(`${API_BASE_URL}/list/${productId}?page=${page}&limit=10`);
        if (!response.ok) throw new Error((await response.json()).message || "Failed to fetch reviews");

        const reviewResponse = await response.json();
        const newReviews = reviewResponse?.data || [];
        const pagination = reviewResponse?.pagination || {};

        currentPage = pagination.currentPage || page;
        totalPages = pagination.totalPages || 1;
        hasMoreReviews = pagination.hasNextPage || false;

        if (append) {
          allProductReviews = [...allProductReviews, ...newReviews];
          appendReviewsToSlideshow(newReviews);
          appendReviewsToDesktopGrid(newReviews);
        } else {
          allProductReviews = newReviews;
          renderReviews(allProductReviews);
        }
        calculateAndRenderSummary(allProductReviews);
        updateLoadMoreButton();
      } catch (error) {
        console.error("Error fetching reviews:", error);
        if (!append) {
          allProductReviews = [];
          calculateAndRenderSummary(allProductReviews);
        }
      } finally {
        if (!append && reviewsSpinner) reviewsSpinner.style.display = "none";
        if (append && loadMoreBtn) {
          loadMoreBtn.disabled = false;
          loadMoreBtn.textContent = "Load More Reviews";
        }
      }
    }

    function updateLoadMoreButton() {
      if (!loadMoreContainer || !loadMoreBtn) return;
      loadMoreContainer.style.display = hasMoreReviews ? "flex" : "none";
    }

    function calculateAndRenderSummary(reviewsArray) {
      if (!reviewSummaryContainer) return;

      if (!reviewsArray || reviewsArray.length === 0) {
        return;
      }

      const totalReviews = reviewsArray.length;
      const sumOfRatings = reviewsArray.reduce((sum, review) => sum + (review.rating || 0), 0);
      const averageRating = totalReviews > 0 ? sumOfRatings / totalReviews : 0;

      const fullStars = Math.floor(averageRating);
      const decimalPart = averageRating - fullStars;
      const hasHalfStar = decimalPart >= 0.25 && decimalPart < 0.75;
      const emptyStars = 5 - fullStars - (hasHalfStar ? 1 : 0);

      let starsHTML = "";

      for (let i = 0; i < fullStars; i++) {
        starsHTML += `<span class="star" style="color:${starColorFilled}; font-size: 1.2em;">&#9733;</span>`;
      }

      if (hasHalfStar) {
        starsHTML += `<span class="star half-star" style="position: relative; display: inline-block; font-size: 1.2em;">
                    <span style="color:${starColorEmpty};">&#9734;</span>
                    <span style="color:${starColorFilled}; position: absolute; overflow: hidden; width: 50%; top: 0; left: 0;">&#9733;</span>
                </span>`;
      }

      for (let i = 0; i < emptyStars; i++) {
        starsHTML += `<span class="star" style="font-size: 24px;">&#9734;</span>`;
      }
    }

    function appendReviewsToSlideshow(newReviews) {
      const slideshowElement = reviewListContainer.querySelector("slideshow-component");
      if (!slideshowElement) return;

      const swiperWrapper = slideshowElement.querySelector(".swiper-wrapper");
      if (!swiperWrapper) return;

      newReviews.forEach((review, index) => {
        const uniqueId = `mobile-review-${Date.now()}-${index}`;
        const reviewDate = review.reviewPlacedAt ? formatDate(review.reviewPlacedAt) : "N/A";
        const ratingStarsHTML = createStarRating(review.rating);
        const imageHtml = review.reviewImage
          ? `<img src="${review.reviewImage}" class="w-full h-full" alt="${review.reviewText?.substring(
              0,
              10,
            )}" loading="lazy">`
          : `<div></div>`;

        const mobileReviewItem = document.createElement("div");
        mobileReviewItem.className = "swiper-slide w-auto h-auto flex flex-col cursor-pointer";
        mobileReviewItem.style.boxSizing = "border-box";
        mobileReviewItem.innerHTML = `
      <div class="flex-1 p-8 box-shadow flex flex-col gap-16 w-300">
        <div class="relative flex justify-center h-220">
          ${imageHtml}
          <div class="absolute bottom-16 bg-brand-2 pt-8 pr-10 pb-8 pl-10 flex gap-4_8 rounded-100">
            ${ratingStarsHTML}
          </div>
        </div>
        <div class="flex flex-col gap-16 flex-1 justify-between h-full">
          <div class="flex flex-col gap-8">
            ${createReviewTextWithReadMore(review.reviewText || "", uniqueId)}
          </div>
          <div class="flex flex-col gap-4">
            <span class="fs-12-lh-16-ls-0_6pct ff-general-sans fw-400 text-label">
              ${reviewDate}
            </span>
            <span class="fs-12-lh-16-ls-0_6pct ff-general-sans fw-400 text-label">
              By ${review.customerName || "Anonymous"}
            </span>
          </div>
        </div>
      </div>
    `;
        mobileReviewItem.addEventListener("click", () => openReviewDetailModal(review));

        swiperWrapper.appendChild(mobileReviewItem);
      });
    }

    function appendReviewsToDesktopGrid(newReviews) {
      const gridContainer = reviewListContainer.querySelector(".product-reviews-grid");
      if (!gridContainer) return;

      newReviews.forEach((review, index) => {
        const uniqueId = `desktop-review-${Date.now()}-${index}`;
        const reviewDate = review.reviewPlacedAt ? formatDate(review.reviewPlacedAt) : "N/A";
        const ratingStarsHTML = createStarRating(review.rating);
        const imageHtml = review.reviewImage
          ? `<img src="${review.reviewImage}" class="w-full h-full" alt="${review.reviewText?.substring(
              0,
              10,
            )}" loading="lazy">`
          : `<div></div>`;

        const desktopReviewItem = document.createElement("div");
        desktopReviewItem.className = "p-8 box-shadow flex flex-col gap-16 cursor-pointer";
        desktopReviewItem.innerHTML = `
      <div class="relative flex justify-center h-220">
        ${imageHtml}
        <div class="absolute bottom-16 bg-brand-2 pt-8 pr-10 pb-8 pl-10 flex gap-4_8 rounded-100">
          ${ratingStarsHTML}
        </div>
      </div>
      <div class="flex flex-col gap-16 flex-1 justify-between h-full">
        <div class="flex flex-col gap-8">
          ${createReviewTextWithReadMore(review.reviewText || "", uniqueId)}
        </div>
        <div class="flex flex-col gap-4">
          <span class="fs-12-lh-16-ls-0_6pct ff-general-sans fw-400 text-label">
            ${reviewDate}
          </span>
          <span class="fs-12-lh-16-ls-0_6pct ff-general-sans fw-400 text-label">
            By ${review.customerName || "Anonymous"}
          </span>
        </div>
      </div>
    `;
        desktopReviewItem.addEventListener("click", () => openReviewDetailModal(review));

        gridContainer.appendChild(desktopReviewItem);
      });
    }

    function renderReviews(reviewsArray) {
      if (!reviewListContainer) return;
      reviewListContainer.innerHTML = "";

      const slideshowComponent = document.createElement("slideshow-component");
      slideshowComponent.setAttribute("data-autoplay", "false");
      slideshowComponent.setAttribute("data-autoplay-delay", "5000");
      slideshowComponent.setAttribute("data-pause-on-hover", "true");
      slideshowComponent.setAttribute("data-enable-carousel", "true");
      slideshowComponent.setAttribute("data-show-progress-bar", "false");
      slideshowComponent.setAttribute("data-nav-loop", "false");
      slideshowComponent.className = "flex-col gap-16 hidden md:hidden lg:hidden sm:flex";

      const swiperContainer = document.createElement("div");
      swiperContainer.className = "swiper-container overflow-hidden pt-10 pr-4 pb-10 pl-4";

      const swiperWrapper = document.createElement("div");
      swiperWrapper.className = "swiper-wrapper flex";

      const gridContainer = document.createElement("div");
      gridContainer.className =
        "product-reviews-grid grid sm:hidden grid-cols-5 lg:grid-cols-4 md:grid-cols-3 gap-24 md:gap-16";

      reviewsArray.forEach((review, index) => {
        const desktopUniqueId = `desktop-review-${Date.now()}-${index}`;
        const mobileUniqueId = `mobile-review-${Date.now()}-${index}`;
        const reviewDate = review.reviewPlacedAt ? formatDate(review.reviewPlacedAt) : "N/A";
        const ratingStarsHTML = createStarRating(review.rating);
        const imageHtml = review.reviewImage
          ? `<img src="${review.reviewImage}" class="w-full h-full" alt="${review.reviewText?.substring(
              0,
              10,
            )}" loading="lazy">`
          : `<div></div>`;

        const desktopReviewItem = document.createElement("div");
        desktopReviewItem.className = "p-8 box-shadow flex flex-col gap-16 cursor-pointer";
        desktopReviewItem.innerHTML = `
      <div class="relative flex justify-center h-220">
        ${imageHtml}
        <div class="absolute bottom-16 bg-brand-2 pt-8 pr-10 pb-8 pl-10 flex gap-4_8 rounded-100">
          ${ratingStarsHTML}
        </div>
      </div>
      <div class="flex flex-col gap-16 flex-1 justify-between h-full">
        <div class="flex flex-col gap-8">
          ${createReviewTextWithReadMore(review.reviewText || "", desktopUniqueId)}
        </div>
        <div class="flex flex-col gap-4">
          <span class="fs-12-lh-16-ls-0_6pct ff-general-sans fw-400 text-label">
            ${reviewDate}
          </span>
          <span class="fs-12-lh-16-ls-0_6pct ff-general-sans fw-400 text-label">
            By ${review.customerName || "Anonymous"}
          </span>
        </div>
      </div>
    `;
        desktopReviewItem.addEventListener("click", () => openReviewDetailModal(review));

        const mobileReviewItem = document.createElement("div");
        mobileReviewItem.className = "swiper-slide w-auto h-auto flex flex-col cursor-pointer";
        mobileReviewItem.style.boxSizing = "border-box";
        mobileReviewItem.innerHTML = `
      <div class="flex-1 p-8 box-shadow flex flex-col gap-16 w-300">
        <div class="relative flex justify-center h-220">
          ${imageHtml}
          <div class="absolute bottom-16 bg-brand-2 pt-8 pr-10 pb-8 pl-10 flex gap-4_8 rounded-100">
            ${ratingStarsHTML}
          </div>
        </div>
        <div class="flex flex-col gap-16 flex-1 justify-between h-full">
          <div class="flex flex-col gap-8">
            ${createReviewTextWithReadMore(review.reviewText || "", mobileUniqueId)}
          </div>
          <div class="flex flex-col gap-4">
            <span class="fs-12-lh-16-ls-0_6pct ff-general-sans fw-400 text-label">
              ${reviewDate}
            </span>
            <span class="fs-12-lh-16-ls-0_6pct ff-general-sans fw-400 text-label">
              By ${review.customerName || "Anonymous"}
            </span>
          </div>
        </div>
      </div>
    `;
        mobileReviewItem.addEventListener("click", () => openReviewDetailModal(review));

        gridContainer.appendChild(desktopReviewItem);
        swiperWrapper.appendChild(mobileReviewItem);
      });

      swiperContainer.appendChild(swiperWrapper);
      slideshowComponent.appendChild(swiperContainer);

      reviewListContainer.appendChild(slideshowComponent);
      reviewListContainer.appendChild(gridContainer);

      setTimeout(() => {
        const slideshowElement = reviewListContainer.querySelector("slideshow-component");
        if (slideshowElement && slideshowElement.swiper) {
          slideshowElement.swiper.on("reachEnd", async () => {
            if (!isLoadingMore && hasMoreReviews) {
              isLoadingMore = true;

              const currentSlideIndex = slideshowElement.swiper.activeIndex;

              try {
                await fetchReviews(currentPage + 1, true);

                if (slideshowElement.swiper) {
                  slideshowElement.swiper.update();
                  slideshowElement.swiper.slideTo(currentSlideIndex, 0);
                }
              } finally {
                isLoadingMore = false;
              }
            }
          });
        }
      }, 500);
    }

    function escapeHTML(str) {
      if (str === null || typeof str === "undefined") return "";
      return str
        .toString()
        .replace(/&/g, "&amp;")
        .replace(/</g, "&lt;")
        .replace(/>/g, "&gt;")
        .replace(/"/g, "&quot;")
        .replace(/'/g, "&#039;");
    }

    if (productId && shopDomain) {
      fetchReviews();
      document.addEventListener("review:submitted", () => fetchReviews());
    } else {
      if (reviewsSpinner) reviewsSpinner.style.display = "none";
    }
  });
})();
